import { Link } from "react-router-dom";
import type { SalesMoveBucket } from "@sales-ops-amplify/shared";
import { SALES_MOVE_BUCKET_LABELS } from "@sales-ops-amplify/shared";

type Props = {
  variant: "all_clear" | "bucket_empty" | "no_data";
  bucket?: SalesMoveBucket | "ALL_ACTIVE";
};

export function SalesMoveEmptyState({ variant, bucket }: Props) {
  if (variant === "no_data") {
    return (
      <div className="rounded-lg border border-border px-6 py-10 text-center">
        <p className="text-base font-semibold text-foreground">No sales moves yet</p>
        <p className="mt-2 text-sm text-muted-foreground">
          Connect or add account, conversation, and deal activity to generate
          recommendations.
        </p>
        <Link
          to="/dashboard"
          className="mt-4 inline-block text-sm font-medium text-brand hover:underline"
        >
          Open Dashboard
        </Link>
      </div>
    );
  }

  if (variant === "bucket_empty" && bucket && bucket !== "ALL_ACTIVE") {
    return (
      <div className="rounded-lg border border-border px-6 py-10 text-center">
        <p className="text-base font-semibold text-foreground">
          No moves in {SALES_MOVE_BUCKET_LABELS[bucket]}
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          Other active moves may still be available.
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-border px-6 py-10 text-center">
      <p className="text-base font-semibold text-foreground">All clear for today</p>
      <p className="mt-2 text-sm text-muted-foreground">
        There are no sales moves requiring attention. Review pipeline on
        Dashboard when you want the full picture.
      </p>
      <Link
        to="/dashboard?view=deal-analytics"
        className="mt-4 inline-flex rounded-md bg-brand px-3 py-2 text-sm font-medium text-brand-foreground hover:opacity-90"
      >
        Open Dashboard
      </Link>
    </div>
  );
}
